import { Snippet } from '../../dataModels';

export const matrixSnippet: Snippet = {
  shiftsummaryDisplyId: '0e601885-bbf3-ec11-9147-005056b29cce',
  displayTemplateId: 'd1354389-e7e3-4af6-a839-48d8448d7fd0',
  name: 'AAA_Mat',
  displayName: 'AAA_Mat',
  description: null,
  order: 4,
  type: 'Matrix',
  enableEdit: 'True',
  enableComment: false,
  isEdited: false,
  configuration: {
    rowTitleKey: 'Column header 1',
    columnCount: 3,
    columns: [
      {
        id: 1,
        name: 'Column header 1',
        displayName: 'Column header 1',
        controlType: 'Checkbox',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 2,
        name: 'Column header 2',
        displayName: 'Column header 2',
        controlType: 'Text',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 3,
        name: 'Column header 3',
        displayName: 'Column header 3',
        controlType: 'DateTime',
        controlValues: null,
        visible: 'True',
      },
    ],
    matrixCells: [
      {
        rowNumber: 1,
        colNumber: 1,
        controlType: 'Checkbox',
        controlValues: null,
      },
      {
        rowNumber: 2,
        colNumber: 1,
        controlType: 'Checkbox',
        controlValues: null,
      },
      {
        rowNumber: 1,
        colNumber: 2,
        controlType: 'Text',
        controlValues: null,
      },
      {
        rowNumber: 1,
        colNumber: 3,
        controlType: 'DateTime',
        controlValues: null,
      },
      {
        rowNumber: 2,
        colNumber: 2,
        controlType: 'Text',
        controlValues: null,
      },
      {
        rowNumber: 2,
        colNumber: 3,
        controlType: 'DateTime',
        controlValues: null,
      },
    ],
  },
  data: [
    {
      rollupDetails: null,
      rowCount: 2,
      rowData: [
        {
          'Column header 1': 'False',
          'Column header 2': null,
          'Column header 3': null,
        },
        {
          'Column header 1': 'True',
          'Column header 2': 'Test Field 1',
          'Column header 3': '2022-06-24T03:00:00Z',
        },
      ],
    },
  ],
  count: 0,
  groupSnippets: null,
  maxRows: 0,
  canAddDeleteRows: false,
};
